import { connect } from 'react-redux';
import WebHost from 'common/src/app/data/enum/WebHost';
import WebHostLink from './WebHostLink';

const WebHostLinkDefault = connect(state => ({
  environmentConfig: state.config.environmentConfig,
}))(WebHostLink);

export { WebHostLinkDefault as default, WebHost };
